"use strict";

import angular from "angular";

/**
 * @component NuNandaMonitoring
 * O <nu-nanda-monitoring> é um componente para mostrar a situação de uma empresa
 */

import template from "./nanda-monitoring.component.html";
import "./themes/nanda-monitoring.component.scss";
import "./themes/nanda-monitoring.component-dark.scss";

const name = "nuNandaMonitoring";
const def = {
    bindings: {
        date: "=",
        label: "=",
        situation: "=",
        viewed: "=",
        action: "=",
        type: "=",
        description: "=",
        companyName: "="
    },
    controllerAs: "nandaMonitoringCtrl",
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
